import { GoogleTagManager } from "components/GoogleTagManager/GoogleTagManager.tsx";
import { AuthLayoutProvider } from "components/Layouts/AuthLayout/AuthLayoutContext.tsx";
import { PaldockFooter } from "components/UI/PaldockFooter/PaldockFooter.tsx";
import { usePageMeta } from "hooks/usePageMeta";
import { FC, PropsWithChildren } from "react";

interface AuthLayoutProps extends PropsWithChildren {
    title?: string;
    logo?: string;
}

export const AuthLayout: FC<AuthLayoutProps> = ({ children, title, logo }) => {
    usePageMeta(title ?? "Paldock");
    return (
        <AuthLayoutProvider logo={logo}>
            <GoogleTagManager />
            <div className="w-full min-h-full bg-[#f9fcfc] flex flex-col overflow-y-auto">
                <main className="flex-1 flex items-center justify-center px-4 py-6">{children}</main>
                <PaldockFooter />
            </div>
        </AuthLayoutProvider>
    );
};
